import React from 'react';
import { DisabledContainer } from '../../atoms/dumb';
import { useBooleanRateLimited, useEffectOnTrueLogPaywall } from '../../../hooks';
import { Tooltip } from './Tooltip';
export const DisabledComponentWithTooltipWrapper = ({
  children,
  uxCopyTooltip,
  onActionTooltip,
  paywall
}) => {
  const wrapperRef = React.useRef(null);
  const [isTooltipOpen, setTooltipOpen] = useBooleanRateLimited();
  if (paywall) {
    useEffectOnTrueLogPaywall(isTooltipOpen, paywall);
  }
  return React.createElement(React.Fragment, null, React.createElement(DisabledContainer, {
    ref: wrapperRef,
    onClick: () => setTooltipOpen(true, true),
    onMouseEnter: () => setTooltipOpen(true),
    onMouseLeave: () => setTooltipOpen(false)
  }, children), uxCopyTooltip && React.createElement(Tooltip, {
    isOpen: isTooltipOpen,
    triggerRef: wrapperRef,
    uxCopy: uxCopyTooltip,
    onAction: onActionTooltip
  }));
};